import React, { ChangeEventHandler, HTMLAttributes } from 'react';
import { getUuidV4 } from '~/utils';
import { ThemeColorKeys } from '~/styles/themes';
import * as S from './Radio.styled';

export type ColorType = Extract<ThemeColorKeys, 'brand' | 'basic'>;

export interface RadioProps
  extends Omit<HTMLAttributes<HTMLLabelElement>, 'onChange'> {
  colorType?: ColorType;
  value: string;
  id?: string;
  name: string;
  disabled?: boolean;
  label?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const Radio = React.forwardRef<HTMLLabelElement, RadioProps>(
  (
    {
      label = true,
      value,
      id: idProp,
      disabled,
      name,
      colorType = 'brand',
      onChange,
      ...props
    },
    forwardedRef,
  ) => {
    const id = idProp ?? getUuidV4();

    return (
      <S.Container
        htmlFor={id}
        ref={forwardedRef}
        colorType={colorType}
        {...props}
      >
        <S.Input
          type='radio'
          value={value}
          id={id}
          disabled={disabled}
          name={name}
          colorType={colorType}
          onChange={onChange}
        />
        <S.Maker />
        {label && <S.Label>{value}</S.Label>}
      </S.Container>
    );
  },
);

export default Radio;
